/* ===================================================================
   AJOUT RAPIDE DEPUIS LES CARTES PRODUIT (31/10/2026)

   Repris du comportement de Manoir de la Chaussure, à la demande de
   Maïwenn : le « + » posé sur la photo ouvre un panneau à droite avec la
   photo, le titre, le prix, les coloris et les tailles. Le bouton reste
   grisé (« Choisissez une taille ») tant que chaque option n'a pas de
   valeur, pour ne jamais mettre une taille au hasard dans le panier.

   - Les options autres que la taille partent sur la première variante
     disponible ; la taille, elle, attend toujours le choix de la cliente.
   - Une taille épuisée reste visible mais barrée et inactive.
   - Après l'ajout : le panneau se ferme et la notification de panier du
     thème s'ouvre (même rendu que depuis une fiche).
   - Si la fiche ne se lit pas (réseau, fiche retirée), on ouvre la fiche
     au lieu d'afficher un panneau vide.
   =================================================================== */
(function () {
  if (window.ajoutRapideCharge) return;
  window.ajoutRapideCharge = true;

  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var etat = { cache: {}, produit: null, choix: [], bouton: null, panneau: null, url: '' };

  var estTaille = function (nom) { return /taille|pointure|size/i.test(nom || ''); };
  var euros = function (centimes) {
    return (centimes / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  };
  var echapper = function (t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var imageTaille = function (src, largeur) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + largeur;
  };

  function varianteChoisie() {
    var p = etat.produit;
    if (!p) return null;
    if (etat.choix.some(function (c) { return c == null; })) return null;
    return p.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === etat.choix[i]; });
    }) || null;
  }

  /* Une valeur est possible si au moins une variante DISPONIBLE la porte
     avec les autres choix déjà faits. */
  function valeurDisponible(index, valeur) {
    return etat.produit.variants.some(function (v) {
      if (!v.available || v.options[index] !== valeur) return false;
      return v.options.every(function (val, i) {
        return i === index || etat.choix[i] == null || estTaille(etat.produit.options[i].name) || val === etat.choix[i];
      });
    });
  }

  function panneau() {
    if (etat.panneau) return etat.panneau;
    var el = document.createElement('div');
    el.className = 'ajout-rapide-panneau';
    el.hidden = true;
    el.innerHTML =
      '<div class="ajout-rapide-panneau__voile" data-ajout-rapide-fermer></div>' +
      '<div class="ajout-rapide-panneau__corps" role="dialog" aria-modal="true" aria-label="Ajout rapide" tabindex="-1">' +
      '<button type="button" class="ajout-rapide-panneau__fermer" data-ajout-rapide-fermer aria-label="Fermer">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button>' +
      '<div class="ajout-rapide-panneau__contenu"></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-ajout-rapide-fermer]')) { fermer(true); return; }
      var choix = evt.target.closest('[data-ajout-rapide-valeur]');
      if (choix && !choix.disabled) {
        etat.choix[Number(choix.getAttribute('data-ajout-rapide-option'))] = choix.getAttribute('data-ajout-rapide-valeur');
        rendu();
        return;
      }
      var ajouter = evt.target.closest('[data-ajout-rapide-ajouter]');
      if (ajouter && !ajouter.disabled) {
        var v = varianteChoisie();
        if (v) ajouterAuPanier(v.id, ajouter);
      }
    });
    etat.panneau = el;
    return el;
  }

  function rendu() {
    var p = etat.produit;
    var v = varianteChoisie();
    var reference = v || p.variants.find(function (x) {
      return x.options.every(function (val, i) { return etat.choix[i] == null || val === etat.choix[i]; });
    }) || p.variants[0];
    var image = (reference.featured_image && reference.featured_image.src) || p.featured_image;
    var prix = reference.price;
    var barre = reference.compare_at_price && reference.compare_at_price > prix ? reference.compare_at_price : null;
    var manque = p.options.findIndex(function (o, i) { return etat.choix[i] == null; });
    var lienFiche = etat.url + (v ? (etat.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id : '');

    var html =
      '<div class="ajout-rapide-panneau__tete">' +
      (image ? '<img src="' + echapper(imageTaille(image, 240)) + '" alt="" width="96" height="96">' : '') +
      '<div><p class="ajout-rapide-panneau__titre">' + echapper(p.title) + '</p>' +
      '<p class="ajout-rapide-panneau__prix">' + (barre ? '<s>' + euros(barre) + '</s> ' : '') + euros(prix) + '</p></div></div>';

    p.options.forEach(function (option, i) {
      var valeurs = [];
      p.variants.forEach(function (x) { if (valeurs.indexOf(x.options[i]) < 0) valeurs.push(x.options[i]); });
      if (valeurs.length < 2 && etat.choix[i] != null) return;
      html += '<fieldset class="ajout-rapide-panneau__option"><legend>' + echapper(option.name) +
        (etat.choix[i] ? ' : <strong>' + echapper(etat.choix[i]) + '</strong>' : '') + '</legend>';
      if (estTaille(option.name)) {
        html += '<a class="ajout-rapide-panneau__guide" href="' + echapper(etat.url) + '#guide-des-tailles">Guide des tailles</a>';
      }
      html += '<div class="ajout-rapide-panneau__valeurs">';
      valeurs.forEach(function (valeur) {
        var possible = valeurDisponible(i, valeur);
        html += '<button type="button" class="ajout-rapide-panneau__valeur' + (etat.choix[i] === valeur ? ' is-choisi' : '') +
          (possible ? '' : ' is-epuise') + '" data-ajout-rapide-option="' + i + '" data-ajout-rapide-valeur="' + echapper(valeur) + '"' +
          (possible ? '' : ' disabled') + ' aria-pressed="' + (etat.choix[i] === valeur) + '">' + echapper(valeur) + '</button>';
      });
      html += '</div></fieldset>';
    });

    var libelle = 'Ajouter au panier';
    if (manque > -1) libelle = estTaille(p.options[manque].name) ? 'Choisissez une taille' : 'Choisissez : ' + p.options[manque].name.toLowerCase();
    else if (!v || !v.available) libelle = 'Épuisé';
    html += '<button type="button" class="button button--full-width ajout-rapide-panneau__ajouter" data-ajout-rapide-ajouter' +
      (v && v.available ? '' : ' disabled') + '>' + libelle + '</button>' +
      '<p class="ajout-rapide-panneau__erreur" role="alert" hidden></p>' +
      '<a class="ajout-rapide-panneau__fiche" href="' + echapper(lienFiche) + '">Voir la fiche du produit</a>';

    panneau().querySelector('.ajout-rapide-panneau__contenu').innerHTML = html;
  }

  function ouvrir(bouton) {
    var handle = bouton.getAttribute('data-ajout-rapide');
    etat.bouton = bouton;
    etat.url = bouton.getAttribute('data-ajout-rapide-url') || racine + 'products/' + handle;
    bouton.setAttribute('aria-busy', 'true');
    var lecture = etat.cache[handle]
      ? Promise.resolve(etat.cache[handle])
      : fetch(racine + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (p) { etat.cache[handle] = p; return p; });
    lecture.then(function (p) {
      bouton.removeAttribute('aria-busy');
      etat.produit = p;
      var premiere = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      etat.choix = p.options.map(function (o, i) {
        var valeurs = [];
        p.variants.forEach(function (x) { if (valeurs.indexOf(x.options[i]) < 0) valeurs.push(x.options[i]); });
        if (valeurs.length === 1) return valeurs[0];
        return estTaille(o.name) ? null : premiere.options[i];
      });
      var el = panneau();
      rendu();
      el.hidden = false;
      document.documentElement.classList.add('ajout-rapide-ouvert');
      requestAnimationFrame(function () {
        el.classList.add('is-ouvert');
        var f = el.querySelector('.ajout-rapide-panneau__fermer');
        if (f) f.focus({ preventScroll: true });
      });
    }).catch(function () {
      bouton.removeAttribute('aria-busy');
      window.location.href = etat.url;
    });
  }

  function fermer(rendreFocus) {
    var el = etat.panneau;
    if (!el || el.hidden) return;
    el.classList.remove('is-ouvert');
    document.documentElement.classList.remove('ajout-rapide-ouvert');
    setTimeout(function () { if (!el.classList.contains('is-ouvert')) el.hidden = true; }, 260);
    if (rendreFocus && etat.bouton && document.body.contains(etat.bouton)) etat.bouton.focus({ preventScroll: true });
  }

  function ajouterAuPanier(idVariante, declencheur) {
    var panier = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var corps = { id: Number(idVariante), quantity: 1 };
    if (panier && typeof panier.getSectionsToRender === 'function') {
      corps.sections = panier.getSectionsToRender().map(function (s) { return s.id; });
      corps.sections_url = window.location.pathname;
    }
    declencheur.setAttribute('aria-busy', 'true');
    declencheur.disabled = true;
    fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        declencheur.removeAttribute('aria-busy');
        declencheur.disabled = false;
        if (!res.ok) {
          var message = res.d.description || res.d.message || 'Ajout impossible pour le moment.';
          var erreur = etat.panneau && etat.panneau.querySelector('.ajout-rapide-panneau__erreur');
          if (erreur && !etat.panneau.hidden) { erreur.textContent = message; erreur.hidden = false; }
          else window.location.href = declencheur.getAttribute('data-ajout-rapide-url') || racine + 'cart';
          return;
        }
        fermer(false);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ajout-rapide', productVariantId: idVariante, cartData: res.d });
        }
        if (panier && typeof panier.renderContents === 'function' && res.d.sections) {
          if (panier.classList) panier.classList.remove('is-empty');
          /* La notification se ferme sur un clic ailleurs : on la laisse
             s'ouvrir APRÈS le clic qui a déclenché l'ajout. */
          setTimeout(function () { panier.renderContents(res.d); }, 0);
        } else {
          window.location.href = racine + 'cart';
        }
      })
      .catch(function () {
        declencheur.removeAttribute('aria-busy');
        declencheur.disabled = false;
      });
  }

  document.addEventListener('click', function (evt) {
    var bouton = evt.target.closest && evt.target.closest('[data-ajout-rapide]');
    if (!bouton) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (bouton.getAttribute('aria-busy') === 'true') return;
    var direct = bouton.getAttribute('data-ajout-rapide-variante');
    if (direct) ajouterAuPanier(direct, bouton);
    else ouvrir(bouton);
  }, true);

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') fermer(true);
  });
})();
